module.exports = __webpack_public_path__ + "static/media/down-arrow.5c50a606.svg";